// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.color-white {
  color: #fff !important; }

.color-black {
  color: black !important; }

.view2-greeting-message {
  background-color: #008c80;
  align-items: center;
  display: flex;
  flex-direction: column;
  color: #ffffff;
  padding: 30px;
  justify-content: center;
  line-height: 1.2;
  text-align: center; }
  .view2-greeting-message .view2-welcome-text {
    font-size: 50px; }
  .view2-greeting-message .view2-welcome-text-highlight {
    font-size: 50px;
    font-weight: bold; }

.view2-greeting-sub-message {
  background-color: #ffffff;
  align-items: center;
  display: flex;
  flex-direction: column;
  color: black;
  padding: 30px; }
  .view2-greeting-sub-message .view2-message-text {
    font-weight: bold;
    text-align: center; }
  .view2-greeting-sub-message .view2-message-sub-text {
    text-align: center;
    margin-top: 30px;
    max-width: 520px; }

.view2-redeem-step-bottom {
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 25px 0; }
  .view2-redeem-step-bottom .view2-redeem-step-bottom-text {
    font-weight: bold;
    margin-top: 20px;
    font-size: 25px; }
  .view2-redeem-step-bottom .view2-redeem-step-bottom-sub-text {
    max-width: 600px;
    text-align: center; }

.view2-info-bottom {
  background-color: #008c80;
  padding: 30px 0px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center; }
  .view2-info-bottom .view2-info-bottom-text {
    color: #fff;
    max-width: 850px;
    text-align: center; }
  .view2-info-bottom .view2-info-bottom-subtext {
    color: #fff;
    margin-top: 15px;
    text-align: center; }

.view2-footer {
  color: #8f8f8f;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px 20px; }
  .view2-footer .view2-footer-text {
    max-width: 900px; }
    .view2-footer .view2-footer-text .text-blue {
      font-weight: 400;
      font-size: 16px;
      line-height: 15.41px;
      color: #005296;
      text-decoration: underline; }

.thankyou-text-wrapper {
  background-color: #f5f5f5; }
  .thankyou-text-wrapper .thankyou-content {
    padding-top: 35px;
    padding-bottom: 40px; }
    @media (max-width: 767px) {
      .thankyou-text-wrapper .thankyou-content {
        padding-top: 39px;
        padding-bottom: 36px; } }
  .thankyou-text-wrapper .thankyou-title {
    font-weight: 850;
    font-size: 32px;
    line-height: 38.39px;
    text-align: center;
    padding: 0 30px; }
    @media (max-width: 767px) {
      .thankyou-text-wrapper .thankyou-title {
        padding: 0 20px; } }
  .thankyou-text-wrapper .thankyou-subtitle {
    font-weight: 700;
    font-size: 16px;
    line-height: 21.79px;
    padding: 44px 30px 0;
    max-width: 800px;
    width: 100%;
    margin: 0 auto; }
    @media (max-width: 767px) {
      .thankyou-text-wrapper .thankyou-subtitle {
        padding: 41px 20px 0; } }
    .thankyou-text-wrapper .thankyou-subtitle .text-red {
      color: red; }
    .thankyou-text-wrapper .thankyou-subtitle .text-gio-blue {
      color: #005296; }
  .thankyou-text-wrapper .thankyou-footer-text {
    font-weight: 400;
    font-size: 11.32px;
    line-height: 15.41px;
    margin-top: 80px;
    margin-bottom: 44px;
    width: 100%;
    max-width: 960px; }
    @media (max-width: 767px) {
      .thankyou-text-wrapper .thankyou-footer-text {
        margin-top: 85px;
        margin-bottom: 0; } }
    .thankyou-text-wrapper .thankyou-footer-text .text-blue {
      font-weight: 400;
      font-size: 16px;
      line-height: 15.41px;
      color: #005296;
      text-decoration: underline; }
`, "",{"version":3,"sources":["webpack://./src/pages/custom-redeem/redeem-success/success.scss"],"names":[],"mappings":"AAAA;EACE,sBAAsB,EAAA;;AAGxB;EACE,uBAAuB,EAAA;;AAGzB;EAEE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB,EAAA;EAVpB;IAYI,eAAe,EAAA;EAZnB;IAeI,eAAe;IACf,iBAAiB,EAAA;;AAIrB;EAEE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa,EAAA;EAPf;IASI,iBAAiB;IACjB,kBAAkB,EAAA;EAVtB;IAcI,kBAAkB;IAElB,gBAAgB;IAChB,gBAAgB,EAAA;;AAIpB;EAGE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,eAAe,EAAA;EANjB;IAQI,iBAAiB;IACjB,gBAAgB;IAEhB,eAAe,EAAA;EAXnB;IAeI,gBAAgB;IAChB,kBAAkB,EAAA;;AAItB;EACE,yBAAyB;EACzB,iBAAiB;EAEjB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB,EAAA;EAPzB;IASI,WAAW;IAEX,gBAAgB;IAChB,kBAAkB,EAAA;EAZtB;IAeI,WAAW;IACX,gBAAgB;IAChB,kBAAkB,EAAA;;AAItB;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB,EAAA;EALpB;IAQI,gBAAgB,EAAA;IARpB;MAUM,gBAAgB;MAChB,eAAe;MACf,oBAAoB;MACpB,cAAc;MACd,0BAA0B,EAAA;;AAKhC;EACE,yBAAyB,EAAA;EAD3B;IAII,iBAAiB;IACjB,oBAAoB,EAAA;IACpB;MANJ;QAOM,iBAAiB;QACjB,oBAAoB,EAAA,EAEvB;EAVH;IAaI,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,eAAe,EAAA;IACf;MAlBJ;QAmBM,eAAe,EAAA,EAElB;EArBH;IAwBI,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,oBAAoB;IACpB,gBAAgB;IAChB,WAAW;IACX,cAAc,EAAA;IACd;MA/BJ;QAgCM,oBAAoB,EAAA,EAQvB;IAxCH;MAmCM,UAAU,EAAA;IAnChB;MAsCM,cAAc,EAAA;EAtCpB;IA2CI,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,gBAAgB,EAAA;IAChB;MAlDJ;QAmDM,gBAAgB;QAChB,gBAAgB,EAAA,EASnB;IA7DH;MAuDM,gBAAgB;MAChB,eAAe;MACf,oBAAoB;MACpB,cAAc;MACd,0BAA0B,EAAA","sourcesContent":[".color-white {\n  color: #fff !important;\n}\n\n.color-black {\n  color: black !important;\n}\n\n.view2-greeting-message {\n  // height: 200px;\n  background-color: #008c80;\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  color: #ffffff;\n  padding: 30px;\n  justify-content: center;\n  line-height: 1.2;\n  text-align: center;\n  .view2-welcome-text {\n    font-size: 50px;\n  }\n  .view2-welcome-text-highlight {\n    font-size: 50px;\n    font-weight: bold;\n  }\n}\n\n.view2-greeting-sub-message {\n  // height: 200px;\n  background-color: #ffffff;\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  color: black;\n  padding: 30px;\n  .view2-message-text {\n    font-weight: bold;\n    text-align: center;\n  }\n\n  .view2-message-sub-text {\n    text-align: center;\n    // width: 550px;\n    margin-top: 30px;\n    max-width: 520px;\n  }\n}\n\n.view2-redeem-step-bottom {\n  // height: 150px;\n  // background-color: grey;\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  padding: 25px 0;\n  .view2-redeem-step-bottom-text {\n    font-weight: bold;\n    margin-top: 20px;\n    // color: #008c80;\n    font-size: 25px;\n  }\n  .view2-redeem-step-bottom-sub-text {\n    // width: 700px;\n    max-width: 600px;\n    text-align: center;\n  }\n}\n\n.view2-info-bottom {\n  background-color: #008c80;\n  padding: 30px 0px;\n  // height: 200px;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  .view2-info-bottom-text {\n    color: #fff;\n    // width: 690px;\n    max-width: 850px;\n    text-align: center;\n  }\n  .view2-info-bottom-subtext {\n    color: #fff;\n    margin-top: 15px;\n    text-align: center;\n  }\n}\n\n.view2-footer {\n  color: #8f8f8f;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 30px 20px;\n  .view2-footer-text {\n    // width: 900px;\n    max-width: 900px;\n    .text-blue {\n      font-weight: 400;\n      font-size: 16px;\n      line-height: 15.41px;\n      color: #005296;\n      text-decoration: underline;\n    }\n  }\n}\n\n.thankyou-text-wrapper {\n  background-color: #f5f5f5;\n\n  .thankyou-content {\n    padding-top: 35px;\n    padding-bottom: 40px;\n    @media (max-width: 767px) {\n      padding-top: 39px;\n      padding-bottom: 36px;\n    }\n  }\n\n  .thankyou-title {\n    font-weight: 850;\n    font-size: 32px;\n    line-height: 38.39px;\n    text-align: center;\n    padding: 0 30px;\n    @media (max-width: 767px) {\n      padding: 0 20px;\n    }\n  }\n\n  .thankyou-subtitle {\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 21.79px;\n    padding: 44px 30px 0;\n    max-width: 800px;\n    width: 100%;\n    margin: 0 auto;\n    @media (max-width: 767px) {\n      padding: 41px 20px 0;\n    }\n    .text-red {\n      color: red;\n    }\n    .text-gio-blue {\n      color: #005296;\n    }\n  }\n\n  .thankyou-footer-text {\n    font-weight: 400;\n    font-size: 11.32px;\n    line-height: 15.41px;\n    margin-top: 80px;\n    margin-bottom: 44px;\n    width: 100%;\n    max-width: 960px;\n    @media (max-width: 767px) {\n      margin-top: 85px;\n      margin-bottom: 0;\n    }\n    .text-blue {\n      font-weight: 400;\n      font-size: 16px;\n      line-height: 15.41px;\n      color: #005296;\n      text-decoration: underline;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
